<template>
	<div class="go-back-trigger" @click="onClick">
		<img src="../../assets/img-v2/ic_running_back.png" />
	</div>
</template>

<script>
export default {
	name: 'goBackTrigger',
	methods: {
		onClick() {
			this.$HomeService.turnToHomeView();
		}
	}
};
</script>

<style scoped lang="scss">
	.go-back-trigger {
		position: fixed;
		top: 10px;
		left: 10px;
		width: 32px;
		height: 32px;
		background: #FFFFFF;
		box-shadow: 0px 0px 6px 0px #AEC4D1;
		border-radius: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 20px;
			height: 20px;
		}
	}
</style>
